<template>
  <div class="messages">
    <div class="title">
      <span></span>
      <h3>Leave a message</h3>
    </div>
    <div class="section-info">
      <div class="info-text">
        <Input v-model="message" type="textarea" :rows="4" placeholder="请输入留言内容" />
        <p>
          <span @click="send">Send</span>
        </p>
      </div>
      <div class="liuyan-main">
        <div class="line" v-for="(list, index) in commentList" :key="'comment' + index">
          <div class="photo">
            <img v-if="list.userInfo.HeadImgUrl" :src="list.userInfo.HeadImgUrl" />
            <img v-else src="@assets/img/empty.png" />
          </div>
          <div class="text">
            <p>{{list.userInfo.NickName}}</p>
            <p>{{list.msgInfo}}</p>
            <!-- <ul class="discuss" v-if="list.children.totalPages > 0">
                    <li v-for="(childList, index) in list.children.itmes" :key="'childComment' + index">
                        <span>{{childList.Users.NickName}}：</span>
                        <span>{{childList.MsgInfo}}</span>
                    </li> 
            </ul>-->
            <p>{{$service.SmarDate(new Date(list.inTime))}}</p>
          </div>
        </div>
      </div>
      <div class="more m-load" v-if="donetTip">
        <span class="load-finish">The end</span>
      </div>
      <div class="more m-load" v-if="!donetTip" @click="loadMore">
        <span class="load-finish">加载更多</span>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@assets/config.json'; // api 请求json  
import { mapActions, mapGetters } from "vuex";

export default {
  name: "leaving-message",
  props: ["typeId", "type"],
  data() {
    return {
      message: "",
      loadState: 1, // 1待加载 2加载中 3全部加载完成
      commentList: [],
      TotalPage: 1, // 页总数
      pageIndex: 1, // 当前页
      pageSize: 20, // 当前页
      options: {},
      getUrl: "", // 获取类型的地址
      sendUrl: "", // 添加类型的地址
      addUrl: "",
      donetTip: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      header: "getHeaders",
      exhibition: "loginModule/getExhibition"
    }),
    loadClass: function() {
      return {
        "z-more": this.loadState === 1,
        "z-ing": this.loadState === 2,
        "z-finish": this.loadState === 3
      };
    }
  },
  watch: {
    '$route' (to, from) {
      if(to){
        this.commentList = [];
        this.TotalPage = 1;
        this.pageIndex = 1;
        this.pageSize = 20;
        this.donetTip = false;
        this.init();
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    loadMore() {
      this.pageIndex += 1;
      this.getComment();
    },
    getComment() {
      // 获取留言
      return new Promise((resolve, reject) => {
        this.$http
          .post(config.api.reqApi + this.getUrl, this.options, this.$store.state.header)
          .then(res => {
            if (res.status === 200 && res.data.items) {
              let arr = [];
              if (this.commentList && this.commentList.length > 0) {
                arr = this.commentList;
              }
              res.data.items.map(c => {
                c.userInfo = JSON.parse(c.userInfo);
              });
              this.commentList = res.data.items;
              if (arr && arr.length > 0) {
                this.commentList = [...arr, ...this.commentList];
              }
              if (this.commentList.length >= res.data.totalCount) {
                console.log("所有数据请求完成", res.data.totalCount);
                this.donetTip = true;
                resolve(this.commentList);
                return;
              }
              console.log("单次数据请求完", res.data.pageIndex);
              console.log(this.commentList, "留言");
              resolve(this.commentList);
            }
          })
          .catch(err => reject(err));
      });
    },

    async send() {
      if (!this.user) {
        this.$Message.warning("请登录后发布");
        this.$emit("showLogin");
        return;
      }

      // 发送评论
      const msg = this.message.trim();
      if (msg === "") return;
      const body = {
        UserId: this.user. userId,
        MsgInfo: msg
      };
      switch (this.type) {
        case "ex": // 展商
          body.CompId = this.typeId;
          break;
        case "pro": // 产品
          body.ProId = this.typeId;
          break;
        case "act": // 活动
          body.ActId = this.typeId;
          break;
      }
      this.$http
        .post(`${config.api.reqApi}${this.sendUrl}`, body, this.header)
        .then(res => {
          if (res.data.successed) {
            this.$Message.success("留言成功！");
            this.commentList = [];
            this.message = '';
            this.getComment();
          }
        })
        .catch(err => {
          this.$Message.error("发布失败，请重试");
        });
    },
    init() {
      switch (this.type) {
        case "ex": // 展商
          this.options = {
            CompId: this.typeId,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          };
          this.getUrl = "/api/CompanyComment/GetByCompId";
          this.sendUrl = "/api/CompanyComment";
          this.getComment();
          break;
        case "pro": // 产品
          this.options = {
            By: this.typeId,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          };
          this.getUrl = "/api/ProductComment/GetByProId";
          this.sendUrl = "/api/ProductComment";
          this.getComment();
          break;
        case "act": // 活动
          this.options = {
            By: this.typeId,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          };
          this.getUrl = "/api/ActivityComment/GetByActId";
          this.sendUrl = "/api/ActivityComment";
          this.getComment();
          break;
      }
    }
  }
};
</script>

<style scoped lang='scss'>
@import "@assets/scss/utils.scss";
.messages {
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  .title {
    position: relative;
    padding-left: 20px;
    display: flex;
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #f5f5f5;
    span {
      display: inline-block;
      width: 4px;
      height: 16px;
      background-color: #d13119;
    }
    h3 {
      display: inline-block;
      font-size: 16px;
      line-height: 18px;
      color: #333;
      margin-left: 15px;
    }
  }
}
.info-text {
  padding: 20px 40px;
  p {
    text-align: right;
  }
  span {
    width: 96px;
    height: 28px;
    background-color: #d13119;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    line-height: 28px;
    text-align: center;
    display: inline-block;
    margin-top: 20px;
    cursor: pointer;
  }
}
.liuyan-main {
  border-top: 1px solid #f5f5f5;
  margin: 0 16px;
  .line {
    @include clearfix;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 20px;
  }
  .line .photo {
    width: 48px;
    height: 48px;
    float: left;
    border-radius: 50%;
    overflow: hidden;
    margin-top: 30px;
  }
  .line .photo img {
    width: 50px;
  }
  .line .text {
    float: left;
    margin: 30px 0 0 20px;
  }
  .line .text p:nth-of-type(1) {
    font-size: 14px;
    color: #999;
  }
  .line .text p:nth-of-type(2) {
    font-size: 14px;
    color: #333;
    margin-top: 8px;
  }
  .line .text p:nth-of-type(3) {
    font-size: 14px;
    color: #999;
    margin-top: 8px;
  }
  .line .text .discuss {
    width: 620px;
    background-color: #f3f5f4;
    list-style: none;
    margin: 10px 0;
    padding-top: 5px;
    padding-bottom: 10px;
  }
  .line .text .discuss li {
    padding: 5px 0 0 10px;
    font-size: 14px;
    color: #333;
  }
  .line .text .discuss li span:nth-of-type(1) {
    color: #1890ff;
  }
}
.more {
  height: 80px;
  text-align: center;
}
.more span {
  color: #040000;
  font-size: 14px;
  cursor: pointer;
  line-height: 80px;
}
</style>